import React, { useEffect, useState } from "react";
import { AiOutlineLoading } from "react-icons/ai";

import { useAdvertisementContext } from "../../../../context/advertisement/advertisementContext";
import { ArrayFill } from "./arrayInit";
import { AdSection } from "./AdSection";
import InfoSection from "./InfoSection";

import {
  news,
  arts,
  homeEv,
  events,
  safari,
  musics,
  foods,
  hotels,
  dances,
  cinema,
  movies,
  homeHot,
  homeSaf,
  museums,
  classes,
  parties,
  homeTour,
  homeBest,
  homeAttr,
  theaters,
  shoppings,
  cityGuide,
  nightlives,
  latestNews,
  thingsTodo,
  ministries,
  happenToday,
  attractions,
  tipsAdvices,
  restaurants,
  thingsToKnow,
  neighborhoods,
} from "./constants";

export const AdModal = ({ event_id, name, setShowModal }) => {
  const [loading, setLoading] = useState(false);
  const [adsList, setAdsList] = useState([]);
  const [refill, setRefill] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const { Advertisement, fetchAdvertisements, createOneAdvertisement } =
    useAdvertisementContext();

  const [news_, setNews] = useState([]);
  const [arts_, setArts] = useState([]);
  const [foods_, setFoods] = useState([]);
  const [events_, setEvents] = useState([]);
  const [safari_, setSafari] = useState([]);
  const [musics_, setMusics] = useState([]);
  const [cinema_, setCinema] = useState([]);
  const [dances_, setDances] = useState([]);
  const [movies_, setMovies] = useState([]);
  const [hotels_, setHotels] = useState([]);
  const [parties_, setParties] = useState([]);
  const [museums_, setMuseums] = useState([]);
  const [classes_, setClasses] = useState([]);
  const [theaters_, setTheaters] = useState([]);
  const [shoppings_, setShoppings] = useState([]);
  const [homeHotels_, setHomeHotel] = useState([]);
  const [cityGuide_, setCityGuide] = useState([]);
  const [latestNews_, setLatestNews] = useState([]);
  const [ministries_, setMinistries] = useState([]);
  const [nightlives_, setNightlives] = useState([]);
  const [thingsTodo_, setThingsTodo] = useState([]);
  const [homeSafari_, setHomeSafari] = useState([]);
  const [homeEvents_, setHomeEvents_] = useState([]);
  const [restaurants_, setRestaurants] = useState([]);
  const [attractions_, setAttractions] = useState([]);
  const [thingsToKnow_, setThingsToKnow] = useState([]);
  const [neighborhoods_, setNeighborhoods] = useState([]);
  const [tipsAndAdvices_, setTipsAndAdvice] = useState([]);
  const [homeAttractions_, setHomeAttraction_] = useState([]);
  const [happenningToday_, setHappenningToday] = useState([]);
  const [homeTourPackages_, setHomeTourPackage] = useState([]);
  const [homeBestOfAfrica_, setHomeBestOfAfrica] = useState([]);

  useEffect(() => {
    if (!Advertisement) fetchAdvertisements();
    else if (Advertisement && adsList.length === 0 && refill === true) {
      setAdsList(Advertisement);
    }
    fillObjectData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Advertisement, adsList]);

  const fillObjectData = () => {
    setHomeAttraction_(ArrayFill(adsList, homeAttr));
    setHomeEvents_(ArrayFill(adsList, homeEv));
    setHomeTourPackage(ArrayFill(adsList, homeTour));
    setHomeSafari(ArrayFill(adsList, homeSaf));
    setHomeHotel(ArrayFill(adsList, homeHot));
    setHomeBestOfAfrica(ArrayFill(adsList, homeBest));
    setHappenningToday(ArrayFill(adsList, happenToday));
    setLatestNews(ArrayFill(adsList, latestNews));
    setThingsToKnow(ArrayFill(adsList, thingsToKnow));
    setEvents(ArrayFill(adsList, events));
    setAttractions(ArrayFill(adsList, attractions));
    setSafari(ArrayFill(adsList, safari));
    setRestaurants(ArrayFill(adsList, restaurants));
    setMusics(ArrayFill(adsList, musics));
    setCinema(ArrayFill(adsList, cinema));
    setNews(ArrayFill(adsList, news));
    setNeighborhoods(ArrayFill(adsList, neighborhoods));
    setDances(ArrayFill(adsList, dances));
    setFoods(ArrayFill(adsList, foods));
    setThingsTodo(ArrayFill(adsList, thingsTodo));
    setMovies(ArrayFill(adsList, movies));
    setCityGuide(ArrayFill(adsList, cityGuide));
    setHotels(ArrayFill(adsList, hotels));
    setArts(ArrayFill(adsList, arts));
    setParties(ArrayFill(adsList, parties));
    setShoppings(ArrayFill(adsList, shoppings));
    setTheaters(ArrayFill(adsList, theaters));
    setTipsAndAdvice(ArrayFill(adsList, tipsAdvices));
    setClasses(ArrayFill(adsList, classes));
    setNightlives(ArrayFill(adsList, nightlives));
    setMuseums(ArrayFill(adsList, museums));
    setMinistries(ArrayFill(adsList, ministries));
  };

  const updatePosition = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    const { response, errorResponse } = await createOneAdvertisement({
      ads: adsList,
    });

    if (response) {
      setSuccess(true);
      setError(null);
      setLoading(false);
      setRefill(true);
      setAdsList([]);
    } else if (errorResponse) {
      setError(true);
      setSuccess(null);
      setLoading(false);
    }
  };

  const _SECTION_MAP_ = [
    { id: homeAttr, title: "Home Attractions", position: homeAttractions_ },
    { id: homeEv, title: "Home Events", position: homeEvents_ },
    { id: homeTour, title: "Home Tour Package", position: homeTourPackages_ },
    { id: homeSaf, title: "Home Safari", position: homeSafari_ },
    { id: homeHot, title: "Home Hotel", position: homeHotels_ },
    { id: homeBest, title: "Home Best Of Africa", position: homeBestOfAfrica_ },
    { id: happenToday, title: "Happening Today", position: happenningToday_ },
    { id: latestNews, title: "Latest News", position: latestNews_ },
    { id: thingsToKnow, title: "Things To Know", position: thingsToKnow_ },
    { id: events, title: "Events Section", position: events_ },
    { id: attractions, title: "Attractions Section", position: attractions_ },
    { id: safari, title: "Safari Section", position: safari_ },
    { id: restaurants, title: "Restaurants Section", position: restaurants_ },
    { id: musics, title: "Musics Section", position: musics_ },
    { id: cinema, title: "Cinema Section", position: cinema_ },
    { id: news, title: "News Section", position: news_ },
    { id: neighborhoods, title: "Neighborhoods Section", position: neighborhoods_ },
    { id: dances, title: "Dances Section", position: dances_ },
    { id: foods, title: "Foods Section", position: foods_ },
    { id: thingsTodo, title: "Things To Do Section", position: thingsTodo_ },
    { id: movies, title: "Movies Section", position: movies_ },
    { id: cityGuide, title: "City Guide Section", position: cityGuide_ },
    { id: hotels, title: "Hotels Section", position: hotels_ },
    { id: arts, title: "Arts Section", position: arts_ },
    { id: parties, title: "Parties Section", position: parties_ },
    { id: shoppings, title: "Shopping Section", position: shoppings_ },
    { id: theaters, title: "Theater Section", position: theaters_ },
    { id: tipsAdvices, title: "Tips And Advices Section", position: tipsAndAdvices_ },
    { id: classes, title: "Classes Section", position: classes_ },
    { id: nightlives, title: "Night Lives Section", position: nightlives_ },
    { id: museums, title: "Museums Section", position: museums_ },
    { id: ministries, title: "Ministries and Companies Section", position: ministries_ },
  ];

  const sectionsCount = _SECTION_MAP_.length;

  return (
    <div>
      <div className="relative flex items-center justify-center">
        {/* Modal shell */}
        <div className="fixed inset-0 z-[150] mx-auto w-11/12 md:w-auto md:mx-4 lg:mx-0 top-3 md:top-8 bottom-3 overflow-hidden">
          {/* Card */}
          <div className="relative mx-auto flex h-full max-h-[90vh] w-full max-w-6xl flex-col rounded-2xl border border-gray-200 bg-white shadow-2xl">
            {/* Ambient glow */}
            <div
              aria-hidden="true"
              className="pointer-events-none absolute -inset-1 rounded-3xl bg-gradient-to-tr from-emerald-200/40 via-amber-200/40 to-purple-200/40 blur-2xl"
            />

            {/* Header */}
            <div className="relative flex items-start justify-between gap-4 border-b border-gray-100 px-5 py-4">
              <div className="text-left">
                <h3 className="text-base font-semibold tracking-tight text-gray-900">
                  Assign advertisement placements
                </h3>
                <p className="mt-0.5 text-xs text-gray-600">
                  Event: <span className="font-medium text-emerald-700">{name}</span> • {sectionsCount} sections
                </p>
              </div>
              <button
                type="button"
                aria-label="Close"
                onClick={() => setShowModal()}
                className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
              >
                <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>

            {/* Body (scrollable) */}
            <form onSubmit={updatePosition} className="relative flex h-full min-h-0 flex-col">
              <div className="flex-1 overflow-y-auto px-5 py-4">
                <div className="mx-auto max-w-5xl">
                  {/* Guidance */}
                  <div className="mb-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
                    <InfoSection />
                  </div>

                  {/* Sections */}
                  <div className="flex flex-col gap-3">
                    {_SECTION_MAP_.map((section, index) => (
                      <AdSection
                        index={index}
                        key={index}
                        id={section.id}
                        adsList={adsList}
                        event_id={event_id}
                        title={section.title}
                        position={section.position}
                        setAdsList={setAdsList}
                        setRefill={setRefill}
                      />
                    ))}
                  </div>

                  {/* Inline alert */}
                  {(error || success) && (
                    <div
                      role="status"
                      aria-live="polite"
                      className={[
                        "mt-4 flex items-center justify-center rounded-xl border px-3 py-2 text-xs font-semibold shadow-sm",
                        error
                          ? "border-red-200 bg-red-50 text-red-700"
                          : "border-emerald-200 bg-emerald-50 text-emerald-700",
                      ].join(" ")}
                    >
                      {error ? "Unexpected error" : "Success"}
                    </div>
                  )}
                </div>
              </div>

              {/* Footer (sticky inside card) */}
              <div className="border-t border-gray-100 bg-white px-5 py-4">
                <div className="mx-auto flex max-w-5xl flex-col-reverse gap-2 sm:flex-row sm:justify-end">
                  <button
                    type="button"
                    onClick={() => setShowModal()}
                    className="inline-flex items-center justify-center rounded-xl border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-800 shadow-sm transition hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
                  >
                    Cancel
                  </button>

                  {loading ? (
                    <button
                      type="button"
                      className="inline-flex items-center justify-center rounded-xl bg-gray-900 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
                    >
                      Saving…
                      <AiOutlineLoading className="ml-2 h-4 w-4 animate-spin" />
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="group relative inline-flex items-center justify-center overflow-hidden rounded-xl bg-gray-900 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
                    >
                      <span className="absolute inset-0 -z-10 bg-gradient-to-r from-emerald-500 via-amber-500 to-purple-500 opacity-0 transition group-hover:opacity-100" />
                      Save changes
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Backdrop */}
      <div className="fixed inset-0 z-[100] h-full w-full bg-black/40" />
    </div>
  );
};
